<Header 
	platformName={platform} 
>
	<div slot="skip-to-content">
		<SkipToContent />
	</div>
</Header>

<Content>
<FluidForm>
	<Grid>

		<Row padding>
			<Column xlg={4}>

			<p>BIOMARKER CODES</p>
			<h1>Password Reset</h1>
			<p style="visibility:hidden;">BIOMARKER CODES</p>

			<TextInput 
				type="email" 
				id="inputEmail" 
				placeholder="Email address" 
				disabled={sentEmail}
				skeleton={loading}
				value={email}
				on:input={event => (email = event.target.value)}
				required
			/>
			</Column>
		</Row>

		<Row padding>
			<Column xlg={4}
			>
				{#if errors}
					{#each errors as error}
						<p>{error}</p>
					{/each}
				{/if}	
			</Column>
		</Row>

		<Row padding>
			<Column xlg={1}>
				<Button 
					kind="gost" 
					disabled={loading||sentEmail}
					icon={Erase32} 
					on:click={e=>{email='';errors=[];}}
				>
					Clear
				</Button>
			</Column>
			<Column xlg={3}>
				<Button 
					class="float-right"
					disabled={emailError||sentEmail} 
					skeleton={loading}
					icon={ArrowRight32}
					on:click={(e)=>reset(email)}
				>
					Send reset link
				</Button>
			</Column>
		</Row>
	</Grid>
</FluidForm>

</Content>

<style lang="scss" global>
  .bx--text-input {
    font-size: large;
  }
</style>

<script>
	export let platform
	import { onDestroy } from 'svelte'
	import { navigate  } from 'svelte-routing'
	import { createEventDispatcher } from "svelte"
	import validate from 'validate.js'

	// Native Carbon Components
	import {
		Header,
		SkipToContent,
		Content,
		FluidForm,
		Button,
		Grid,
		Row,
		Column,
		TextInput,
		Link,
	} from "carbon-components-svelte"
	import ArrowRight32 from "carbon-icons-svelte/lib/ArrowRight32"
	import Erase32 from "carbon-icons-svelte/lib/Erase32"

	import { Functions } from '../../config/firebase'

  const dispatch = createEventDispatcher()


	let email = ''
	let loading = false
	let errors=[]
	let sentEmail = false
	$: emailError = validate.single(email, {presence: true, email: true})

	async function reset(email) {
		loading = true
          
		const passwordReset = Functions.httpsCallable('passwordReset')
		passwordReset({ email })
			.then((res) => {
				if (res.data.result) {
					sentEmail = true
					loading = false
					errors = [...errors, "An email with a password reset link is on it's way" ]
				} else {
					throw new Error("Ooops, something went wrong ...")
				}		
			})
			.catch((error) => {
				errors = [...errors, error.message ]
			})
	}
	
</script>